export default __webpack_public_path__ + "static/media/willyou.beaeea20.png";